<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2fm"><a id="page_ix">Contents</a></h2><a id="page_ix">
</a><p class="tocfm"><a id="page_ix"></a><a href="#/xhtml/ack">Acknowledgments</a></p>
<p class="tocfm"><a href="#/xhtml/foreword">Foreword <span class="fonttoc">By Candace Pert, PhD</span></a></p>
<p class="tocfm"><a href="#/xhtml/intro">Introduction <span class="fonttoc">(Revised from the 2008 Edition)</span></a></p>
<p class="tocc"><a href="#/xhtml/ch01">Chapter 1	<span class="fonttoc">Dr. Jekyll and Mr. Hyde</span></a></p>
<p class="tocc"><a href="#/xhtml/ch02">Chapter 2	<span class="fonttoc">Are You Sugar Sensitive?</span></a></p>
<p class="tocc"><span href="#/xhtml/ch03" title="Link target outside of Sample">Chapter 3	<span class="fonttoc">What You Were Like as a Child</span></span></p>
<p class="tocc"><span href="#/xhtml/ch04" title="Link target outside of Sample">Chapter 4	<span class="fonttoc">It’s Not Your Fault</span></span></p>
<p class="tocc"><span href="#/xhtml/ch05" title="Link target outside of Sample">Chapter 5	<span class="fonttoc">The Ups and Downs of Blood Sugar</span></span></p>
<p class="tocc"><span href="#/xhtml/ch06" title="Link target outside of Sample">Chapter 6	<span class="fonttoc">Brain Chemistry 101</span></span></p>
<p class="tocc"><span href="#/xhtml/ch07" title="Link target outside of Sample">Chapter 7	<span class="fonttoc">The First Step: Getting Started</span></span></p>
<p class="tocc"><span href="#/xhtml/ch08" title="Link target outside of Sample">Chapter 8	<span class="fonttoc">The Second Step: Keeping a Food Journal</span></span></p>
<p class="tocc"><span href="#/xhtml/ch09" title="Link target outside of Sample">Chapter 9	<span class="fonttoc">The Third Step: Three Meals a Day</span></span></p>
<p class="tocc"><span href="#/xhtml/ch10" title="Link target outside of Sample">Chapter 10	<span class="fonttoc">The Fourth and Fifth Steps: Vitamins, Potato, and Browns</span></span></p>
<p class="tocc"><span href="#/xhtml/ch11" title="Link target outside of Sample">Chapter 11	<span class="fonttoc">The Sixth Step: Dealing with Sugars</span></span></p>
<p class="tocc"><span href="#/xhtml/ch12" title="Link target outside of Sample">Chapter 12	<span class="fonttoc">The Seventh Step: Coming Alive</span></span></p>
<p class="tocc"><span href="#/xhtml/ch13" title="Link target outside of Sample">Chapter 13	<span class="fonttoc">Learning About Feelings</span></span></p>
<p class="tocc"><span href="#/xhtml/ch14" title="Link target outside of Sample">Chapter 14	<span class="fonttoc">Learning More About Feelings</span></span></p>
<p class="tocc"><span href="#/xhtml/ch15" title="Link target outside of Sample">Chapter 15<span class="fonttoc">Converting Addiction to Recovery</span></span><a id="page_x"></a></p><a id="page_x">
</a><p class="tocc"><a id="page_x"></a><span href="#/xhtml/ch16" title="Link target outside of Sample">Chapter 16	<span class="fonttoc">Healing Your Body</span></span></p>
<p class="tocc"><span href="#/xhtml/gloss" title="Link target outside of Sample">Glossary</span></p>
<p class="tocc"><span href="#/xhtml/resources" title="Link target outside of Sample">Resources</span></p>
<p class="tocc"><span href="#/xhtml/app" title="Link target outside of Sample">Appendix <span class="fonttoc">The Scientific Basis of Sugar Sensitivity</span></span></p>
<p class="tocc"><span href="#/xhtml/bio" title="Link target outside of Sample">About the Author</span></p>
<p class="tocc"><span href="#/xhtml/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="tocc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?17ec6cf2